import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginWithPassword, sendOtp } from "../../services/api/authApi";
import { useAuth } from "../../Context/AuthContext";
import { extractErrorMessage } from "../../services/api/errorHandler";
import AuthLayout from "./components/AuthLayout";
import { AlertIcon, ShieldIcon, SpinnerIcon } from "./components/AuthIcons";
import { dashboardPathFor } from "./components/loginUtils";

function LoginPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const phone = location.state?.phone || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!phone) navigate("/LoginNumber", { replace: true });
  }, [phone, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!password) return setError("رمز عبور را وارد کنید");
    setLoading(true);
    setError("");
    try {
      const response = await loginWithPassword(phone, password);
      if (!response.success || !response.data) throw new Error(response.message || "ورود ناموفق بود");
      login(response.data.token, response.data.user);
      navigate(dashboardPathFor(response.data.user), { replace: true });
    } catch (err) {
      setError(extractErrorMessage(err, "رمز عبور نادرست است"));
    } finally {
      setLoading(false);
    }
  };

  const continueWithCode = async (resetPassword = false) => {
    if (!phone || loading) return;
    setLoading(true);
    setError("");
    try {
      const response = await sendOtp(phone);
      if (!response.success) {
        throw new Error(response.message || "ارسال کد ورود ناموفق بود");
      }
      navigate("/LoginCode", { state: { phone, resetPassword } });
    } catch (err) {
      setError(extractErrorMessage(err, "ارسال کد ورود ناموفق بود"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout badgeIcon={<ShieldIcon size={26} />} title="ورود با رمز عبور" subtitle={phone ? `رمز عبور حساب ${phone} را وارد کنید` : "رمز عبور خود را وارد کنید"}>
      <form className="auth-form" onSubmit={handleSubmit} noValidate>
        <div className="auth-field">
          <label className="auth-label" htmlFor="login-password"><ShieldIcon size={17} />رمز عبور</label>
          <div className="auth-input-wrap">
            <input id="login-password" className={`auth-input${error ? " auth-input-error" : ""}`} type="password" autoComplete="current-password" value={password} onChange={(e) => { setPassword(e.target.value); setError(""); }} disabled={loading} autoFocus />
          </div>
        </div>
        {error && <p className="auth-alert auth-alert-error" role="alert"><AlertIcon size={18} /><span>{error}</span></p>}
        <button className="auth-btn auth-btn-primary" type="submit" disabled={loading || !phone}>{loading && <SpinnerIcon />}{loading ? "در حال ورود..." : "ورود به حساب"}</button>
        <button className="auth-btn auth-btn-code" type="button" onClick={() => continueWithCode()} disabled={loading}>
          {loading && <SpinnerIcon />}
          ورود با کد یکبارمصرف
        </button>
        <button className="auth-btn auth-btn-link" type="button" onClick={() => continueWithCode(true)} disabled={loading}>
          فراموشی رمز عبور
        </button>
      </form>
    </AuthLayout>
  );
}

export default LoginPassword;
